<template>
    <b-container fluid>
        <!-- User Interface controls -->
        <b-row>
            <b-col md="3" class="my-1 ml-0">

            </b-col>
            <b-col sm="5"></b-col>
            <b-col md="4" class="my-1">
                <b-form-group
                        label="Filter"
                        label-cols-sm="2"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="filterInput"
                        class="mb-0"
                >
                    <b-input-group size="sm">
                        <b-form-input
                                v-model="filter"
                                type="search"
                                id="filterInput"
                                placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <br>

        <!-- Main table element -->
        <b-table
                show-empty
                small
                striped
                stacked="md"
                :items="items = []"
                :busy="account.accountLoading"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :filterIncludedFields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
        >

            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>

            <template v-slot:cell(serial)="row">
                {{ row.index + 1 }}
            </template>

            <template v-slot:cell(amount)="row">
                {{ row.item.amount | toCurrency  }}
            </template>

            <template v-slot:cell(actions)="row">
                <b-button size="xs" @click="row.toggleDetails">
                    Details
                </b-button>
            </template>

            <template v-slot:row-details="row">
                <b-card>
                    <ul>
                        <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                    </ul>
                </b-card>
            </template>
        </b-table>

        <b-row>
            <b-col md="3" class="my-1 ml-0">
                <b-form-group
                        label="Per page"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="perPageSelect"
                        class="mb-0"
                >
                    <b-form-select
                            v-model="perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="pageOptions"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="5"></b-col>
            <b-col sm="4" md="4" class="my-1 mr-0">
                <b-pagination
                        v-model="currentPage"
                        :total-rows="items.length"
                        :per-page="perPage"
                        align="fill"
                        size="sm"
                        class="my-0"
                ></b-pagination>
            </b-col>
        </b-row>

        <!-- Info modal -->
        <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
            <pre>{{ infoModal.content }}</pre>
        </b-modal>
    </b-container>
</template>

<script>


    export default {
        props:[ 'isBusy', 'accounts', 'trans'],
        data() {
            return {
                'fields': [
                    { key: 'serial',   label: 'Serial', sortable: true, class: 'text-left' },
                    { key: 'txndate',   label: 'Date', sortable: true, class: 'text-left' },
                    { key: 'contractref',   label: 'Tran.Ref.', sortable: true, class: 'text-left' },
                    { key: 'account',   label: 'Acc. Number', sortable: true, class: 'text-left' },
                    { key: 'amount',   label: 'Amount', sortable: true, class: 'text-left' },
                    { key: 'counterpartyservice',   label: 'Service', sortable: true, class: 'text-left' },
                    { key: 'counterparty',   label: 'Party', sortable: true, class: 'text-left' },
                    { key: 'drcr',   label: 'Debit/Credit', sortable: true, class: 'text-left' },
                    { key: 'actions', label: 'Actions' }
                ],
                totalRows: 1,
                currentPage: 1,
                perPage: 5,
                pageOptions: [5, 10, 15, 20],
                sortBy: '',
                account: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                },



            }
        },
        computed: {
            items(){
                return this.$store.state.account.statements
            },
            transactions(){
                return this.$store.state.account.statements
            },
            getAccounts() {
                return this.accounts;
            },



        },
        mounted() {
            //this.items = this.trans
        },
        methods: {

            info(item, index, button) {
                this.infoModal.title = `Row index: ${index}`;
                this.infoModal.content = JSON.stringify(item, null, 2);
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            resetInfoModal() {
                this.infoModal.title = '';
                this.infoModal.content = ''
            },
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1
            },
            loadtrans(){
                this.$store.dispatch('account/updateStatements', this.transactions.filter(account => account.account === this.sortBy))
            }
        }
    }
</script>
